export default {"src":"/_next/static/media/minus-small-icon-cart.32bf6ecb.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};